import { render, staticRenderFns } from "./DiagnosisAndSummary.vue?vue&type=template&id=cc3670a4&"
import script from "./DiagnosisAndSummary.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisAndSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc3670a4')) {
      api.createRecord('cc3670a4', component.options)
    } else {
      api.reload('cc3670a4', component.options)
    }
    module.hot.accept("./DiagnosisAndSummary.vue?vue&type=template&id=cc3670a4&", function () {
      api.rerender('cc3670a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/DiagnosisAndSummary.vue"
export default component.exports